!function (t, e) {
  for (var n in e) {
    t[n] = e[n];
  }
}(exports, function (t) {
  var e = {};

  function n(r) {
    if (e[r]) return e[r].exports;
    var o = e[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = t, n.c = e, n.d = function (t, e, r) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var o in t) {
      n.d(r, o, function (e) {
        return t[e];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 1);
}([function (t, e, n) {
  "use strict";

  n.r(e), n.d(e, "__extends", function () {
    return o;
  }), n.d(e, "__assign", function () {
    return _i;
  }), n.d(e, "__rest", function () {
    return u;
  }), n.d(e, "__decorate", function () {
    return a;
  }), n.d(e, "__param", function () {
    return c;
  }), n.d(e, "__metadata", function () {
    return f;
  }), n.d(e, "__awaiter", function () {
    return l;
  }), n.d(e, "__generator", function () {
    return s;
  }), n.d(e, "__createBinding", function () {
    return p;
  }), n.d(e, "__exportStar", function () {
    return y;
  }), n.d(e, "__values", function () {
    return d;
  }), n.d(e, "__read", function () {
    return h;
  }), n.d(e, "__spread", function () {
    return v;
  }), n.d(e, "__spreadArrays", function () {
    return b;
  }), n.d(e, "__await", function () {
    return _;
  }), n.d(e, "__asyncGenerator", function () {
    return m;
  }), n.d(e, "__asyncDelegator", function () {
    return w;
  }), n.d(e, "__asyncValues", function () {
    return O;
  }), n.d(e, "__makeTemplateObject", function () {
    return g;
  }), n.d(e, "__importStar", function () {
    return j;
  }), n.d(e, "__importDefault", function () {
    return S;
  }), n.d(e, "__classPrivateFieldGet", function () {
    return x;
  }), n.d(e, "__classPrivateFieldSet", function () {
    return k;
  });
  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */

  var _r = function r(t, e) {
    return (_r = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
    })(t, e);
  };

  function o(t, e) {
    function n() {
      this.constructor = t;
    }

    _r(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
  }

  var _i = function i() {
    return (_i = Object.assign || function (t) {
      for (var e, n = 1, r = arguments.length; n < r; n++) {
        for (var o in e = arguments[n]) {
          Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        }
      }

      return t;
    }).apply(this, arguments);
  };

  function u(t, e) {
    var n = {};

    for (var r in t) {
      Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
    }

    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;

      for (r = Object.getOwnPropertySymbols(t); o < r.length; o++) {
        e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
      }
    }

    return n;
  }

  function a(t, e, n, r) {
    var o,
        i = arguments.length,
        u = i < 3 ? e : null === r ? r = Object.getOwnPropertyDescriptor(e, n) : r;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) u = Reflect.decorate(t, e, n, r);else for (var a = t.length - 1; a >= 0; a--) {
      (o = t[a]) && (u = (i < 3 ? o(u) : i > 3 ? o(e, n, u) : o(e, n)) || u);
    }
    return i > 3 && u && Object.defineProperty(e, n, u), u;
  }

  function c(t, e) {
    return function (n, r) {
      e(n, r, t);
    };
  }

  function f(t, e) {
    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
  }

  function l(t, e, n, r) {
    return new (n || (n = Promise))(function (o, i) {
      function u(t) {
        try {
          c(r.next(t));
        } catch (t) {
          i(t);
        }
      }

      function a(t) {
        try {
          c(r.throw(t));
        } catch (t) {
          i(t);
        }
      }

      function c(t) {
        var e;
        t.done ? o(t.value) : (e = t.value, e instanceof n ? e : new n(function (t) {
          t(e);
        })).then(u, a);
      }

      c((r = r.apply(t, e || [])).next());
    });
  }

  function s(t, e) {
    var n,
        r,
        o,
        i,
        u = {
      label: 0,
      sent: function sent() {
        if (1 & o[0]) throw o[1];
        return o[1];
      },
      trys: [],
      ops: []
    };
    return i = {
      next: a(0),
      throw: a(1),
      return: a(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
      return this;
    }), i;

    function a(i) {
      return function (a) {
        return function (i) {
          if (n) throw new TypeError("Generator is already executing.");

          for (; u;) {
            try {
              if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

              switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                case 0:
                case 1:
                  o = i;
                  break;

                case 4:
                  return u.label++, {
                    value: i[1],
                    done: !1
                  };

                case 5:
                  u.label++, r = i[1], i = [0];
                  continue;

                case 7:
                  i = u.ops.pop(), u.trys.pop();
                  continue;

                default:
                  if (!(o = u.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                    u = 0;
                    continue;
                  }

                  if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                    u.label = i[1];
                    break;
                  }

                  if (6 === i[0] && u.label < o[1]) {
                    u.label = o[1], o = i;
                    break;
                  }

                  if (o && u.label < o[2]) {
                    u.label = o[2], u.ops.push(i);
                    break;
                  }

                  o[2] && u.ops.pop(), u.trys.pop();
                  continue;
              }

              i = e.call(t, u);
            } catch (t) {
              i = [6, t], r = 0;
            } finally {
              n = o = 0;
            }
          }

          if (5 & i[0]) throw i[1];
          return {
            value: i[0] ? i[1] : void 0,
            done: !0
          };
        }([i, a]);
      };
    }
  }

  var p = Object.create ? function (t, e, n, r) {
    void 0 === r && (r = n), Object.defineProperty(t, r, {
      enumerable: !0,
      get: function get() {
        return e[n];
      }
    });
  } : function (t, e, n, r) {
    void 0 === r && (r = n), t[r] = e[n];
  };

  function y(t, e) {
    for (var n in t) {
      "default" === n || Object.prototype.hasOwnProperty.call(e, n) || p(e, t, n);
    }
  }

  function d(t) {
    var e = "function" == typeof Symbol && Symbol.iterator,
        n = e && t[e],
        r = 0;
    if (n) return n.call(t);
    if (t && "number" == typeof t.length) return {
      next: function next() {
        return t && r >= t.length && (t = void 0), {
          value: t && t[r++],
          done: !t
        };
      }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }

  function h(t, e) {
    var n = "function" == typeof Symbol && t[Symbol.iterator];
    if (!n) return t;
    var r,
        o,
        i = n.call(t),
        u = [];

    try {
      for (; (void 0 === e || e-- > 0) && !(r = i.next()).done;) {
        u.push(r.value);
      }
    } catch (t) {
      o = {
        error: t
      };
    } finally {
      try {
        r && !r.done && (n = i.return) && n.call(i);
      } finally {
        if (o) throw o.error;
      }
    }

    return u;
  }

  function v() {
    for (var t = [], e = 0; e < arguments.length; e++) {
      t = t.concat(h(arguments[e]));
    }

    return t;
  }

  function b() {
    for (var t = 0, e = 0, n = arguments.length; e < n; e++) {
      t += arguments[e].length;
    }

    var r = Array(t),
        o = 0;

    for (e = 0; e < n; e++) {
      for (var i = arguments[e], u = 0, a = i.length; u < a; u++, o++) {
        r[o] = i[u];
      }
    }

    return r;
  }

  function _(t) {
    return this instanceof _ ? (this.v = t, this) : new _(t);
  }

  function m(t, e, n) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var r,
        o = n.apply(t, e || []),
        i = [];
    return r = {}, u("next"), u("throw"), u("return"), r[Symbol.asyncIterator] = function () {
      return this;
    }, r;

    function u(t) {
      o[t] && (r[t] = function (e) {
        return new Promise(function (n, r) {
          i.push([t, e, n, r]) > 1 || a(t, e);
        });
      });
    }

    function a(t, e) {
      try {
        (n = o[t](e)).value instanceof _ ? Promise.resolve(n.value.v).then(c, f) : l(i[0][2], n);
      } catch (t) {
        l(i[0][3], t);
      }

      var n;
    }

    function c(t) {
      a("next", t);
    }

    function f(t) {
      a("throw", t);
    }

    function l(t, e) {
      t(e), i.shift(), i.length && a(i[0][0], i[0][1]);
    }
  }

  function w(t) {
    var e, n;
    return e = {}, r("next"), r("throw", function (t) {
      throw t;
    }), r("return"), e[Symbol.iterator] = function () {
      return this;
    }, e;

    function r(r, o) {
      e[r] = t[r] ? function (e) {
        return (n = !n) ? {
          value: _(t[r](e)),
          done: "return" === r
        } : o ? o(e) : e;
      } : o;
    }
  }

  function O(t) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var e,
        n = t[Symbol.asyncIterator];
    return n ? n.call(t) : (t = d(t), e = {}, r("next"), r("throw"), r("return"), e[Symbol.asyncIterator] = function () {
      return this;
    }, e);

    function r(n) {
      e[n] = t[n] && function (e) {
        return new Promise(function (r, o) {
          (function (t, e, n, r) {
            Promise.resolve(r).then(function (e) {
              t({
                value: e,
                done: n
              });
            }, e);
          })(r, o, (e = t[n](e)).done, e.value);
        });
      };
    }
  }

  function g(t, e) {
    return Object.defineProperty ? Object.defineProperty(t, "raw", {
      value: e
    }) : t.raw = e, t;
  }

  var P = Object.create ? function (t, e) {
    Object.defineProperty(t, "default", {
      enumerable: !0,
      value: e
    });
  } : function (t, e) {
    t.default = e;
  };

  function j(t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for (var n in t) {
      "default" !== n && Object.prototype.hasOwnProperty.call(t, n) && p(e, t, n);
    }
    return P(e, t), e;
  }

  function S(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }

  function x(t, e) {
    if (!e.has(t)) throw new TypeError("attempted to get private field on non-instance");
    return e.get(t);
  }

  function k(t, e, n) {
    if (!e.has(t)) throw new TypeError("attempted to set private field on non-instance");
    return e.set(t, n), n;
  }
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.Particles = void 0;

  var r = n(0),
      o = r.__importDefault(n(2));

  e.Particles = o.default, r.__exportStar(n(6), e), e.default = o.default;
}, function (t, e, n) {
  "use strict";

  function r(t) {
    return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }

  function o(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }

  function i(t, e, n) {
    return (i = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
      var r = function (t, e) {
        for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = l(t));) {
          ;
        }

        return t;
      }(t, e);

      if (r) {
        var o = Object.getOwnPropertyDescriptor(r, e);
        return o.get ? o.get.call(n) : o.value;
      }
    })(t, e, n || t);
  }

  function u(t, e) {
    return (u = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }

  function a(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var n,
          r = l(t);

      if (e) {
        var o = l(this).constructor;
        n = Reflect.construct(r, arguments, o);
      } else n = r.apply(this, arguments);

      return c(this, n);
    };
  }

  function c(t, e) {
    return !e || "object" !== r(e) && "function" != typeof e ? f(t) : e;
  }

  function f(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }

  function l(t) {
    return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var s = n(0).__importStar(n(3)),
      p = n(4),
      y = n(5),
      d = function (t) {
    !function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && u(t, e);
    }(d, t);
    var e,
        n,
        r,
        c = a(d);

    function d(t) {
      var e;
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, d), (e = c.call(this, t)).state = {
        canvas: void 0,
        library: void 0
      }, e.loadCanvas = e.loadCanvas.bind(f(e)), e;
    }

    return e = d, (n = [{
      key: "destroy",
      value: function value() {
        this.state.library && (this.state.library.destroy(), this.setState({
          library: void 0
        }));
      }
    }, {
      key: "loadCanvas",
      value: function value(t) {
        var e = this;
        t && this.setState({
          canvas: t
        }, function () {
          var n = e.state.library;
          n && (n.canvas.loadCanvas(t), n.start());
        });
      }
    }, {
      key: "shouldComponentUpdate",
      value: function value(t) {
        return !y.isEqual(t, this.props);
      }
    }, {
      key: "componentDidUpdate",
      value: function value() {
        this.refresh(this.props);
      }
    }, {
      key: "forceUpdate",
      value: function value() {
        this.refresh(this.props), i(l(d.prototype), "forceUpdate", this).call(this);
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        var t;
        this.setState({
          library: this.buildParticlesLibrary(this.props.id, null !== (t = this.props.params) && void 0 !== t ? t : this.props.options)
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.destroy();
      }
    }, {
      key: "render",
      value: function value() {
        var t = this.props,
            e = t.width,
            n = t.height,
            r = t.className,
            o = t.canvasClassName,
            i = t.id;
        return s.default.createElement("div", {
          className: r,
          id: i
        }, s.default.createElement("canvas", {
          ref: this.loadCanvas,
          className: o,
          style: Object.assign(Object.assign({}, this.props.style), {
            width: e,
            height: n
          })
        }));
      }
    }, {
      key: "buildParticlesLibrary",
      value: function value(t, e) {
        try {
          if (void 0 === window) return;
        } catch (t) {
          return;
        }

        p.tsParticles.init();
        var n = new p.Container(null != t ? t : d.defaultProps.id, e);
        return this.props.container && (this.props.container.current = n), n;
      }
    }, {
      key: "refresh",
      value: function value(t) {
        var e,
            n = this,
            r = this.state.canvas;
        r && (this.destroy(), this.setState({
          library: this.buildParticlesLibrary(t.id, null !== (e = t.params) && void 0 !== e ? e : t.options)
        }, function () {
          n.loadCanvas(r);
        }));
      }
    }]) && o(e.prototype, n), r && o(e, r), d;
  }(s.Component);

  e.default = d, d.defaultProps = {
    width: "100%",
    height: "100%",
    options: {},
    style: {},
    id: "tsparticles"
  };
}, function (t, e) {
  t.exports = require("react");
}, function (t, e) {
  t.exports = require("tsparticles");
}, function (t, e) {
  t.exports = require("lodash");
}, function (t, e) {
  t.exports = require("tsparticles/dist/Enums");
}]));